import React from 'react'
import { Button } from '@dostavkee/web-ui'
import { Link } from '@tanstack/react-router'

import { useAuthIsAuthenticated } from '@/entities/auth'
import { notFoundImage } from '@/shared/assets'

import styles from './not-found.module.scss'

export const NotFound = () => {
    const { isAuthenticated } = useAuthIsAuthenticated()

    return (
        <section className={styles['not-found']}>
            <div>
                <img alt='404' src={notFoundImage} />
                <h1>Страница не найдена</h1>
                <Link to={isAuthenticated ? '/recruitment' : '/login'}>
                    <Button variant='primary'>{isAuthenticated ? 'На главную' : 'Войти'}</Button>
                </Link>
            </div>
        </section>
    )
}

NotFound.displayName = 'NotFound'
